module.exports = __webpack_public_path__ + "img/MapThumb_SpiralValley.ea1a54a5.webp";